import { ISpoilageService } from './ISpoilageService';
import { of as observableOf, Observable } from 'rxjs';
import { HttpRequestService } from '../../http-request.service';
import { apiURLs, PREVILEGEKEY } from '../../../globalcontants';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SpoilageEntity } from '../../../models/Transactions/SpoilageEntity';
import { ValidationEntity } from '../../../models/Utilities/ValidationEntity';
import { SpoilageStatusHeaderEntity } from 'src/app/shared/models/Transactions/SpoilageHeadEntity';

@Injectable({
  providedIn: 'root'
})
export class SpoilageService implements ISpoilageService {
  constructor(private httpService: HttpRequestService) { }

  // tslint:disable-next-line: max-line-length
  GetSpoilageSummary(menuId: number, siteId: number, selectedLocationId: number = 0, searchText: string = ''): Observable<SpoilageEntity[]> {
    let inputParams = new HttpParams().set('menuId', menuId.toString()).set('siteId', siteId.toString())
    .set('selectedLocationId', selectedLocationId.toString())
    .set('APIKEY', PREVILEGEKEY.GetSpoilageSummary);
    if (searchText !== '') {
      inputParams = inputParams.append('searchValue', searchText.toString());
    }
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.SpoilageAPI.GetSpoilageSummary);
  }
 /**
   * @version UI 13.2
   * @method GetTransGetSpoilageSummary
   */
  // GetTransGetSpoilageSummary(SpoilageRequestParams: any): Observable<any> {
  //   const requisitionRequestUrl = apiURLs.TransactionManagement.GetTransGetSpoilageSummary + SpoilageRequestParams
  //   return this.httpService.GetHttpRequest(requisitionRequestUrl);
  // }

  GetTransactionSpoilage(SpoilageRequestParams: any): Observable<any> {
    const requisitionRequestUrl = apiURLs.TransactionManagement.GetTransactionSpoilage
    return this.httpService.postHttpRequest(requisitionRequestUrl, SpoilageRequestParams);
  }

  GetAllSpoilage(SpoilageRequestParams: any): Observable<any> {
    const requisitionRequestUrl = apiURLs.TransactionManagement.GetAllSpoilage
    return this.httpService.postHttpRequest(requisitionRequestUrl, SpoilageRequestParams);
  }
  
  GetTransGetSpoilageDetails(SpoilageDetailsRequestParams: any): Observable<any> {
    const requisitionRequestUrl = `${apiURLs.TransactionManagement.GetTransGetSpoilageSummary}/${SpoilageDetailsRequestParams}?transtype=11`;
    return this.httpService.GetHttpRequest(requisitionRequestUrl);
  }

  // GetSpoilageSummary(RequisitionRequestParams: any): Observable<any> {
  //   const requisitionRequestUrl = apiURLs.SpoilageAPI.GetSpoilageSummary + RequisitionRequestParams
  //   return this.httpService.GetHttpRequest(requisitionRequestUrl);
  // }
  
  GetSpoilageDetails(spoilageNumber: number): Observable<SpoilageEntity> {
    const inputParams = new HttpParams().set('spoilageNumber', spoilageNumber.toString());
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.SpoilageAPI.GetSpoilageDetails);
  }
  PostSpoilage(entity: SpoilageEntity): Observable<ValidationEntity> {
    (entity as any).APIKEY = PREVILEGEKEY.PostSpoilage;
    return this.httpService.postHttpRequest(apiURLs.SpoilageAPI.SaveSpoilage, entity);
  }
  /* Get Transaction Status Summary */
  GetSpoilageHeaderSummary(typeId: number = 5): Observable<SpoilageStatusHeaderEntity> {
    const requestUrl = apiURLs.SpoilageAPI.GetSpoilageStatusSummary + typeId;
    return this.httpService.GetHttpRequest(requestUrl);
  }
  GetSpoilageInventoryLocations(LocationParams: any): Observable<any> {
    const locationRequestUrl = apiURLs.InvertoryManagement.GetInventoryLocation + LocationParams;
    return this.httpService.GetHttpRequest(locationRequestUrl);
  }
  GetSpoilageReasons(LocationParams: any): Observable<any> {
    const locationRequestUrl = apiURLs.SpoilageAPI.GetSpoilageReasonDetails + LocationParams;
    return this.httpService.GetHttpRequest(locationRequestUrl);
  }
  GetSpoilageDetail(transType: number, menuId: number, requisitionNumber: number, userId: number = 0, siteId: number = 0)
  : Observable<SpoilageEntity> {
    const inputParams = new HttpParams()
    .set('transType', transType.toString())
    .set('menuId', menuId.toString())
    .set('requisitionNumber', requisitionNumber.toString())
    .set('userId', userId.toString())
    .set('siteId', siteId.toString());
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.RequisitionAPI.GetRequisitionDetails);
      //return this.httpService.GetHttpRequestId(inputParams, apiURLs.SpoilageAPI.GetSpoilageDetails);
  }

  /**
   * @version 13.2 UI
   * @param PostTrans 
   * @returns 
   */
   PostSpoilageandLoss(entity: any): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.TransactionManagement.GetTransGetSpoilageSummary, entity);
  }
}
